import {Box} from '@lapilli-ui/components';
const Badge = ({className, label, backgroundColor, color, top}) =>{
  return <Box className={`ywcas-badge ${className}`} sx={{top:`${top}px`,backgroundColor, color}}>{label}</Box>
}

export default Badge;